import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    storageKey: { type: String, default: "left_sidebar_pinned" },
  };

  connect() {
    this.applyPinnedFromStorage();
  }

  togglePin() {
    const nextPinned = !this.isPinned();
    this.setPinned(nextPinned);
  }

  isPinned() {
    return this.element.classList.contains("is-pinned");
  }

  setPinned(pinned) {
    this.element.classList.toggle("is-pinned", pinned);
    try {
      window.localStorage.setItem(this.storageKeyValue, pinned ? "1" : "0");
    } catch (_) {
      // ignore
    }
  }

  applyPinnedFromStorage() {
    try {
      const raw = window.localStorage.getItem(this.storageKeyValue);
      this.setPinned(raw === "1");
    } catch (_) {
      this.setPinned(false);
    }
  }
}

